<template>
    <div class="detailsContainer">
        <h1>POLECAMY</h1>
        <div>
            <div
                v-for="(item, index) in list"
                :key="index"
            >
                <div class="image">
                    <div :style="{ backgroundImage: `url(/assets/img/offer/${item.zdjecie})` }"></div>
                </div>
                <h3>Oferta {{ item.oferta_nr }} ({{ item.transakcja }})</h3>
                <p>Cena: {{ item.cena }} PLN</p>
                <p>Powierzchnia: {{ item.powierzchnia }} m<sup>2</sup></p>
                <p>Lokalizacja: {{ item.lokalizacja }}</p>
                <div>
                    <router-link :to="`/search/details/${item.oferta_id}`">Więcej</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SpecialOfferBox",
    data () {
        return {
            list: null
        };
    },
    async created () {
        try {
            let response = await fetch(process.env.VUE_APP_XHR, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        mode: 'list',
                        type: 'special',
                        page: this.$route.params.page || 1
                    })
                }
            )
            this.list = await response.json();
        } catch (err) {
            console.log(err)
        }
    }
}
</script>

<style lang="scss" scoped>
.detailsContainer {
    max-width: 1200px;
    min-height: 200px;
    margin: 0 auto;
    padding: 20px;
    background: #eeeeee;

    h1 {
        text-align: center;
        font: 32px/64px 'Google Sans';
        color: #ff1111;
        text-transform: uppercase;
        margin: 30px 0;
        padding-bottom: 20px;
    }

    div {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;

        div {
            width: 360px;
            margin-bottom: 20px;
            text-align: left;
            display: block;

            .image {
                width: 360px;
                height: 280px;
                background-size: cover;
                background-image: url("/assets/no-photo-available.png");

                > div {
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                }

            }

            h3 {
                font: 18px "Google Sans";
                color: #ff1111;
            }

            p {
                font: 16px "Roboto Condensed";
            }

            div {
                text-align: right;

                a {
                    color: #ff1111;
                    display: inline-block;
                    font: 16px "Roboto Condensed";
                    text-decoration: none;
                    padding: 10px 20px;
                    transition: all 300ms;

                    &:hover {
                        color: #fff;
                        background: #ff1111;
                        box-shadow: #333333 0 0 5px 0;
                    }
                }
            }
        }
    }
}
</style>